import React, { useEffect, useState, useRef } from "react";
import classes from "./MemberSaving.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { Eye, Edit, Trash } from 'lucide-react';
import api, { BASE_URL, getAuthHeaders } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import SavingModal from "./SavingModal/SavingModal";
import SavingsUpload from "./SavingsExcelUpload";
import SavingsUpload1 from "./SavingsExcelUpload1";
import WithdrawalReceipt from "./SavingModal/WithdrawalReceipt";



const MemberSavings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [showReceipt, setShowReceipt] = useState(false);
const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);
  const printRef = useRef();
  const [receiptType, setReceiptType] = useState("savings"); // Default to "savings"
  const [openCashReciept, setOpenCashReciept] = useState(false);

  const [savingsExcel, setSavingsExcel] = useState(false);
  const [savingsExcel1, setSavingsExcel1] = useState(false);
  
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };





  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/v1/fetch-purchases-invoice`, {
  //         headers: getAuthHeaders(),
  //       });
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);



 const fetchInvoices = async () => {
  setLoading(true);

  try {
    const res = await api.get("/v1/account/fetch-all-members-savings-transactions");

    const savings = res.data?.data?.savings?.data || [];

    setInvoices(savings);
  } catch (error) {
    console.error(error);
    setInvoices([]);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchInvoices();
}, []);

  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };


  const getDeliveryStatus = (item) => {
    const rawValue = item?.is_supplied ?? item?.delivery_status ?? item?.status;

    if (rawValue == 1 || rawValue === "1") {
      return { text: "delivered", class: classes.greenStatus };
    }
    if (rawValue == 0 || rawValue === "0") {
      return { text: "not delivered", class: classes.yellowStatus };
    }

    return { text: String(rawValue || "not delivered"), class: classes.yellowStatus };
  };
  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/purchase-invoice-matrix");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      }
    };
    fetchMetrics();
  }, []);

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData, pageTitle: "Purchase Invoice" },
    });
  };

  const handleReversePurchaseInvoice = async (item) => {
    // Confirm deletion
    const result = await Swal.fire({
      title: 'Reverse Purchase Invoice',
      text: 'Are you sure you want to reverse this purchase invoice? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, {
        invoice_id: item.id,
        invoice_number: item.invoice_number || item.document_number
      });

      if (response.status === 200 || response.status === 201) {
        // Remove the item from the table
        setInvoices(invoices.filter(invoice => invoice.id !== item.id));
        Swal.fire({
          title: 'Success!',
          text: 'Purchase invoice reversed successfully.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Failed to reverse invoice:", error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing purchase invoice. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      });
    }
  };

const handlePrintReceipt = (item) => {
  const receipt = {
    memberName: item.member?.name,
    amount: Number(item.credit || item.amount || 0),
    transactionDate: item.transaction_date,
    description: item.description,
    reference:
      item.cheque_no ||
      item.uuid ||
      item.savings_number ||
      item.transaction_reference ||
      "-",
    savingsNumber:
      item.cheque_no ||
      item.uuid ||
      item.transaction_reference ||
      "-",
    status: "SUCCESSFUL",
    currency: {
      currency: "Naira",
      symbol: "₦",
      fraction: "Kobo",
    },
  };

  setReceiptType("history");   // opened from printer
  setReceiptData(receipt);
  setShowReceipt(true);
};


  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

    

      <div className={classes.Container}>
        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Members Savings</h2>
          <h1 className={classes.Titles}>
            View and Manage Savings.
          </h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Savings</p>
                <p className={classes.kdptg1}>
                {/* {selectMetrics?.total_purchase?.toLocaleString() ?? '0'} */}
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Withdrawal</p>
                <p className={classes.kdptg2}>
                {/* {selectMetrics?.outstanding?.toLocaleString() ?? '0'} */}
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total Withdrawal</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>
                {/* {selectMetrics?.total_invoices?.toLocaleString() ?? '0'} */}
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search savings" />
            </div>
            {/* <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div> */}

            {/* <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div> */}
          </div>
          <div className={classes.fbtnlay}>
           <button className={classes.btnss1} 
          onClick={() => setSavingsExcel1(true)}
          > + Upload Excel</button>
          <button className={classes.btnss} 
          // onClick={() => 
          // navigate("/transactions/purchase-invoice/purchase/new-item")}
          onClick={() => setOpenCashReciept(true)}
          > 
          + New savings
          </button>

          </div>
        </div>

        <div className={classes.invoicecont}>
          {/* <table className={classes.invoiceTable}> */}
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  {/* <th>Description</th> */}
                  <th>Member Number</th>
                  <th>Members Name</th>
                  <th>Product Name</th>
                  {/* <th>Description</th> */}
                  <th>Transaction Date</th>
                  <th>Credit</th>
                  <th>Balance</th>
                  {/* <th>Payment Status</th>
                  <th>Post Date</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(8)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No savings record found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                       <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.member?.member_number}</td>
                      <td>{item.member?.name}</td>
                      <td>{item.type?.product_name}</td>
                      {/* <td>{item.description}</td> */}
                      <td>{item.transaction_date}</td>
                     <td style={{ textAlign: 'right' }}>{Number(item.credit).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                     <td style={{ textAlign: 'right' }}>{Number(item.balance).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                     <td className={classes.tableCell}>
                        <div className={classes.actionIcons}>
                          <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                          <Edit 
                            size={16} 
                            style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)', cursor: 'pointer' }}
                            // onClick={() => handleEditClick(customer)}
                          />
                          <Printer
    size={16}
    style={{
      marginRight: "8px",
      color: "#111827",
      cursor: "pointer",
    }}
    onClick={() => handlePrintReceipt(item)}
  />
                          <Trash size={16} style={{ color: 'rgb(255, 2, 2)' }} />
                        </div>
                        </td>
                      {/* <td className={classes.actions}>
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 
                            size={16} 
                            className={classes.deleteIcon}
                            onClick={() => handleReversePurchaseInvoice(item)}
                            style={{ cursor: "pointer" }}
                          />
                          <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} />
                        </td> */}

                      {/* <td>{item.description}</td> */}
                      {/* <td>{Number(item.amount).toLocaleString()}</td> */}
                      {/* <td>{item.created_at?.split("T")[0]}</td> */}
                    </tr>
                    
                      
                    ))
                  )}
              </tbody>
            </table>

{/* 
          </table> */}

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - 41 of 41</span>
            </div>
          </div>


        </div>
      </div>
      <SavingModal
        isOpen={openCashReciept}
        onClose={() => setOpenCashReciept(false)}
        onSuccess={(data) => {
          setReceiptType("saving");      // came from SavingModal
          setReceiptData(data);
          setShowReceipt(true);
        }}
      />
    <WithdrawalReceipt
  isOpen={showReceipt}
  data={receiptData}
  onClose={() => {
    setShowReceipt(false);

    if (receiptType === "saving") {
      fetchInvoices();      // only refresh after a new saving
    }
  }}
/>
           <SavingsUpload1
        isOpen={savingsExcel1}
        onClose={() => setSavingsExcel1(false)}
        onUploadDocument={() => {
          setSavingsExcel1(false); // Close SavingsUpload1
          setSavingsExcel(true);   // Open SavingsUpload
        }}
      />
       <SavingsUpload 
       isOpen={savingsExcel} 
       onClose={() => setSavingsExcel(false)
       }
        onSuccess={fetchInvoices}
        />
      <Footer />
    </div>
  );
};

export default MemberSavings;
